const Belts = () => {
	return <h1>Belts</h1>;
  };
  
  export default Belts;